// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "document_import".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { appointmentResourceSourceValues, documentImportKindValues, documentImportStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "document_import" table (1:1 with a DB row, on the wire). */
export const documentImportAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    uploadedByUserId: z.string().nullable(),
    fileName: z.string(),
    storageKey: z.string(),
    mimeType: z.string(),
    sizeBytes: z.number(),
    status: z.enum(documentImportStatusValues),
    documentKind: z.enum(documentImportKindValues).nullable(),
    matchedLeadId: z.string().nullable(),
    matchSource: z.enum(appointmentResourceSourceValues).nullable(),
    patientDocumentId: z.string().nullable(),
    confidence: z.number().nullable(),
    extracted: z.unknown().nullable(),
    candidates: z.unknown().nullable(),
    matchReason: z.string().nullable(),
    failureReason: z.string().nullable(),
    processedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=documentImport.js.map